<template>
  <div>
    {{ /* eslint-disable-next-line */ }}
    <ui-save-bar v-if="isShopify" ref="polarisBar">
      <button
        :loading="discardLoading"
        :disabled="saveLoading || discardLoading"
        @click="
          discardLoading = true;
          saveActions.discard();
        "
      >
        Discard
      </button>
      <button
        :disabled="saveActions?.disabled || saveLoading || discardLoading"
        :loading="saveLoading"
        @click="
          saveLoading = true;
          saveActions.save();
        "
        variant="primary"
      >
        Save
      </button>
    </ui-save-bar>
    <p-box
      v-else
      v-show="saveActions"
      background="bg-surface"
      overflowX="clip"
      overflowY="clip"
      :padding="{ xs: 400 }"
      style="
        --pc-box-border-radius: var(--p-border-radius-200);
        --pc-box-shadow: var(--p-shadow-200);
      "
      class="shopify-savebar gap-4 justify-end"
    >
      <p-btn
        :disabled="saveLoading || discardLoading"
        @click="
          discardLoading = true;
          saveActions.discard();
        "
        :loading="discardLoading"
        >Discard</p-btn
      >
      <p-btn
        :disabled="saveActions?.disabled || saveLoading || discardLoading"
        :loading="saveLoading"
        @click="
          saveLoading = true;
          saveActions.save();
        "
        variant="primary"
        >Save</p-btn
      >
    </p-box>
  </div>
</template>

<script>
import PBox from '@/components/polaris/PBox.vue';
import PBtn from '@/components/polaris/PBtn.vue';

export default {
  name: 'ShopifySavebar',
  components: { PBtn, PBox },
  data() {
    return {
      saveActions: null,
      saveLoading: false,
      discardLoading: false,
    };
  },
  computed: {
    isShopify() {
      return !!window.shopify || !!window.Shopify;
    },
  },
  beforeDestroy() {
    window.removeEventListener('saveform-changed');
  },
  mounted() {
    window.addEventListener('saveform-changed', ev => {
      if (this.$refs.polarisBar) {
        const action = ev.detail ? 'show' : 'hide';
        this.$refs.polarisBar[action]();
      }

      this.saveActions = ev.detail;
      if (!ev.detail) {
        this.saveLoading = false;
        this.discardLoading = false;
      }
    });
  },
};
</script>

<style scoped lang="scss">
.shopify-savebar {
  position: fixed;
  display: flex;
  bottom: 2rem;
  left: 6rem;
  right: 6rem;
  z-index: 90;
}
</style>
